import {
  ThemeProvider as MuiThemeProvider,
  createTheme,
} from "@material-ui/core/styles";
import { ptBR } from "@material-ui/core/locale";
import React from "react";
import { ThemeProvider } from "styled-components";

import GlobalStyle from "styles/global";
import lightTheme from "styles/themes/light";
import { NoSsr } from "@material-ui/core";

const theme = createTheme(
  {
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 1280,
        lg: 1366,
        xl: 1920,
      },
    },
    palette: {
      primary: {
        main: "#0033C6",
      },
      secondary: {
        main: "#fff",
      },
    },
    props: {
      MuiInputLabel: {
        margin: "dense",
      },
      MuiOutlinedInput: {
        margin: "dense",
      },
    },
  },
  ptBR
);

const Theme: React.FC = ({ children }) => (
  <MuiThemeProvider theme={theme}>
    <ThemeProvider theme={lightTheme}>
      <NoSsr>{children}</NoSsr>
      <GlobalStyle />
    </ThemeProvider>
  </MuiThemeProvider>
);

export default Theme;
